module.exports = dibs_buyer_layout;


//////////////////
// WEBPACK FOOTER
// external "dibs_buyer_layout"
// module id = 4233
// module chunks = 62